module.exports = __webpack_public_path__ + "img/img_cardbg.7c86d317.jpg";